// offRestCevirici.js — GERÇEKLEŞMİŞ GÖREVİN BOZDUĞU OFF → REST, TEK YAZICI (1 Eki 2026)
//
// 🔑 Serkan (1 Eki 2026): *"gerçekleşmiş bir uçuş arşive gittiğinde daha önceden girilmiş bir off gününü etkiliyorsa
//    o off rest olarak güncellenir"* · *"roster güncellenmesi gerekir"* · kural motorda, yazan her yoldan çağrılır
//    (*"başlayalım A'ya"*). Kural: FTLEngine.gercekGorevinBozduguOfflar · cümle: FTLEngine.offRestMetni.
// YAZAN YOLLAR (beşi de BURADAN geçer): uçuş EDIT'i · yer görevi "it took place" · geriye dönük atama / PAPER OFP ·
//    yer görevi EDIT'i · archive-flight (iPad arşivi, Deno — bu yüzden React/Supabase içe aktarılmaz, istemci
//    dışarıdan gelir; içe aktarmalar `.js` uzantılı).
// SIRA (29 Eyl deseni): İZ ÖNCE (`ftl_duty_edits`), sonra satır `cancelled` — SİLME YOK (İlke 4). Yazma dönen satırla
//    doğrulanır (RLS reddi hata değil 0 satır döner, İlke 2); yazılamayan için izine DÜZELTME SATIRI düşer.
import { gercekGorevinBozduguOfflar, offRestMetni, offDonusumu } from './FTLEngine.js';

/**
 * duties: pilot(lar)ın kayıtları — yazmadan ÖNCEKİ hâl yeter (görevin son hâli `gorevler`de) ·
 * gorevler: kaydedilen görevlerin SON hâli; yalnız `status: 'actual'` olanlar ölçülür ·
 * kurallar: (gorev) => rules — görevin kendi kural seti (snapshot) ya da şirketinki ·
 * tzOf: (pilotId) => pilotun ana üs dilimi (OFF'un yeri yoksa boş gün onunla ölçülür).
 * @param {any} db Supabase istemcisi (web: oturum · Edge: service role)
 * @param {{ duties: any[], gorevler: any[], kurallar: (g: any) => any, offTypes?: any[] | null,
 *           tzOf?: (pilotId: string) => (string | null), editedBy?: string | null, kaynak?: string }} secenek
 * @returns {Promise<{ cevrilen: string[], hata: string | null }>} cevrilen: insan-okur cümleler
 */
export async function offlariRestYap(db, { duties, gorevler, kurallar, offTypes = null, tzOf = () => null,
                                           editedBy = null, kaynak = 'web' }) {
  const bulunan = [];
  const gorulen = new Set();
  for (const g of (gorevler || [])) {
    if (!g || g.status !== 'actual' || g.duty_type === 'off') continue;
    for (const x of gercekGorevinBozduguOfflar(duties, g.pilot_id, g, kurallar(g), { offTypes, tz: tzOf(g.pilot_id) })) {
      if (gorulen.has(x.off.id)) continue;
      gorulen.add(x.off.id);
      bulunan.push(x);
    }
  }
  if (!bulunan.length) return { cevrilen: [], hata: null };

  const iz = (x, ek) => ({
    duty_id: x.off.id, customer_id: x.off.customer_id ?? null, pilot_id: x.off.pilot_id,
    assignment_id: x.off.assignment_id || null, edited_by: editedBy, ...ek,
  });
  const { error: izHata } = await db.from('ftl_duty_edits').insert(bulunan.map(x => iz(x, {
    // 4 Eki 2026: gününde görev → DUTY, yalnız gecesi → REST (`offDonusumu`, Md.18(1)).
    edit_type: 'CANCEL', field_name: 'day_nature', old_value: `OFF ${x.off.off_subtype || 'OFF'}`, new_value: offDonusumu(x.gece).deger,
    reason: `${offRestMetni(x)} [${kaynak}]`,
  })));
  if (izHata) return { cevrilen: [], hata: `OFF → REST not applied — audit write failed: ${izHata.message}` };

  const { data, error } = await db.from('crew_duties').update({ status: 'cancelled' })
    .in('id', bulunan.map(x => x.off.id)).select('id');
  const olan = new Set((data || []).map(r => r.id));
  const yazilmayan = bulunan.filter(x => !olan.has(x.off.id));
  let hata = null;
  if (yazilmayan.length) {
    const sebep = error?.message || 'no row returned (permission?)';
    const { error: dHata } = await db.from('ftl_duty_edits').insert(yazilmayan.map(x => iz(x, {
      edit_type: 'EDIT', field_name: 'day_nature', old_value: '(OFF → REST logged)',
      new_value: '(NOT WRITTEN — OFF still recorded)', reason: `Update refused: ${sebep}`,
    })));
    hata = `OFF → REST NOT written for ${yazilmayan.map(x => x.tarih).join(', ')}: ${sebep}`
      + (dHata ? ` — the audit correction could not be written either: ${dHata.message}` : '');
  }
  return { cevrilen: bulunan.filter(x => olan.has(x.off.id)).map(offRestMetni), hata };
}
